<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div id="pageTable" class="mainView">
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex xs12 sm6 md2>
                    <v-text-field
                            mask="############"
                            label="별도 정산할 기사 운행 고유번호"
                            v-model="driverUsageId"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                    <v-btn color="primary" dark @click="getDriverUsage">조회</v-btn>
                </v-flex>

                <template v-if="driverUsage">
                    <v-flex lg12>
                        <v-toolbar dark color="primary" flat dense cad>
                            <v-toolbar-title class="subheading">운행 정보</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-list three-line subheader>
                            <v-data-table
                                    :headers="complex.driverUsageHeader1"
                                    :items="complex.items"
                                    hide-actions
                                    class="elevation-1"
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-sm-center">
                                        <router-link :to="{ name: 'components/driverUsageHistoryDetail', params: {id: props.item.id}}" target="_blank">
                                            {{props.item.id}}
                                        </router-link>
                                    </td>
                                    <td class="text-sm-center">{{props.item.callOption}}</td>
                                    <td class="text-sm-center">{{props.item.callAcceptTimestamp}}</td>
                                    <td class="text-sm-center">{{props.item.state}}</td>
                                    <td class="text-sm-center">{{props.item.startLocationName}}</td>
                                    <td class="text-sm-center">{{props.item.endLocationName}}</td>
                                </template>
                            </v-data-table>
                        </v-list>

                        <v-divider></v-divider>

                        <v-list three-line subheader>
                            <v-data-table
                                    :headers="complex.driverUsageHeader2"
                                    :items="complex.items"
                                    hide-actions
                                    class="elevation-1"
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-sm-center">{{props.item.matchingHistory.pickupUserId1}} -> {{props.item.matchingHistory.pickupUserId2}}</td>
                                    <td class="text-sm-center">{{props.item.matchingHistory.dropOffUserId1}} -> {{props.item.matchingHistory.dropOffUserId2}}</td>
                                    <td class="text-sm-center">{{props.item.matchingHistory.callHistory1.startLocationName}}</td>
                                    <td class="text-sm-center">{{props.item.matchingHistory.callHistory2.startLocationName}}</td>
                                    <td class="text-sm-center">{{props.item.matchingHistory.dropOffUserId1 == props.item.matchingHistory.callHistory1.passengerId ? props.item.matchingHistory.callHistory1.endLocationName : props.item.matchingHistory.callHistory2.endLocationName}}</td>
                                    <td class="text-sm-center">{{props.item.matchingHistory.dropOffUserId2 == props.item.matchingHistory.callHistory1.passengerId ? props.item.matchingHistory.callHistory1.endLocationName : props.item.matchingHistory.callHistory2.endLocationName}}</td>
                                </template>
                            </v-data-table>
                        </v-list>

                        <template v-if="driverUsage.driverUsageCancelHistory">
                            <v-toolbar dark color="primary" flat dense cad>
                                <v-toolbar-title class="subheading">취소 내역</v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-list three-line subheader>
                                <v-data-table
                                        :headers="complex.driverUsageCancelHistoryHeader"
                                        :items="complex.items"
                                        hide-actions
                                        class="elevation-1"
                                >
                                    <template slot="items" slot-scope="props">
                                        <td class="text-sm-center">{{ changeRunningStateText(props.item.driverUsageCancelHistory.driverStatus) }}</td>
                                        <td class="text-sm-center">{{ props.item.driverUsageCancelHistory.requestUserType == 'P' ? '승객' : '기사' }}</td>
                                        <td class="text-sm-center">{{ changeCallCancelReasonText(props.item.driverUsageCancelHistory.reason) }}</td>
                                    </template>
                                </v-data-table>
                            </v-list>
                        </template>

                        <v-toolbar dark color="primary" flat dense cad>
                            <v-toolbar-title class="subheading">기사 정보</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-list three-line subheader>
                            <v-data-table
                                    :headers="complex.driverHeader"
                                    :items="complex.items"
                                    hide-actions
                                    class="elevation-1"
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-sm-center">
                                        <router-link :to="{ name: 'components/driverMemberDetail', params: {id: props.item.driverId}}" target="_blank">{{ props.item.driverId }}</router-link>
                                    </td>
                                    <td class="text-sm-center">{{ props.item.driver.personalInfo.name }}</td>
                                    <td class="text-sm-center">{{ props.item.driver.phoneNumber }}</td>
                                    <td class="text-sm-center">{{ props.item.carNum }}</td>
                                    <td class="text-sm-center">{{ props.item.carModelName }}</td>
                                </template>
                            </v-data-table>
                        </v-list>

                        <v-toolbar dark color="primary" flat dense cad>
                            <v-toolbar-title class="subheading">승객1 정보</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>

                        <v-list three-line subheader>
                            <v-data-table
                                    :headers="complex.passengerHeader"
                                    :items="complex.items"
                                    hide-actions
                                    class="elevation-1"
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-sm-center">
                                        <router-link :to="{ name: 'components/passengerMemberDetail', params: {id: props.item.matchingHistory.callHistory1.passenger.id}}" target="_blank">
                                            {{ props.item.matchingHistory.callHistory1.passenger.id }}
                                        </router-link>
                                    </td>
                                    <td class="text-sm-center">{{ props.item.matchingHistory.callHistory1.passenger.name }}</td>
                                    <td class="text-sm-center">{{ props.item.matchingHistory.callHistory1.passenger.phoneNumber }}</td>
                                    <td class="text-sm-center">{{changeGenderText(props.item.matchingHistory.callHistory1.passenger.gender)}}</td>
                                    <td class="text-sm-center">{{ props.item.matchingHistory.frontUserId == props.item.matchingHistory.callHistory1.passenger.id ? '앞 좌석' : '뒷 좌석' }}</td>
                                    <td class="text-sm-center">{{ props.item.matchingHistory.callHistory1.soloPredictTotalFee }}</td>
                                    <td class="text-sm-center">{{ props.item.matchingHistory.predictTaxiFee1 }}</td>
                                    <td class="text-sm-center">{{ props.item.matchingHistory.callHistory1.startLocationName }}</td>
                                    <td class="text-sm-center">{{ props.item.matchingHistory.callHistory1.endLocationName }}</td>
                                </template>
                            </v-data-table>
                        </v-list>

                        <v-toolbar dark color="primary" flat dense cad>
                            <v-toolbar-title class="subheading">승객2 정보</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-list three-line subheader>
                            <v-data-table
                                    :headers="complex.passengerHeader"
                                    :items="complex.items"
                                    hide-actions
                                    class="elevation-1"
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-sm-center">
                                        <router-link :to="{ name: 'components/passengerMemberDetail', params: {id: props.item.matchingHistory.callHistory2.passenger.id}}" target="_blank">
                                            {{ props.item.matchingHistory.callHistory2.passenger.id }}
                                        </router-link>
                                    </td>
                                    <td class="text-sm-center">{{ props.item.matchingHistory.callHistory2.passenger.name }}</td>
                                    <td class="text-sm-center">{{ props.item.matchingHistory.callHistory2.passenger.phoneNumber }}</td>
                                    <td class="text-sm-center">{{changeGenderText(props.item.matchingHistory.callHistory2.passenger.gender)}}</td>
                                    <td class="text-sm-center">{{ props.item.matchingHistory.frontUserId == props.item.matchingHistory.callHistory2.passenger.id ? '앞 좌석' : '뒷 좌석' }}</td>
                                    <td class="text-sm-center">{{ props.item.matchingHistory.callHistory2.soloPredictTotalFee }}</td>
                                    <td class="text-sm-center">{{ props.item.matchingHistory.predictTaxiFee2 }}</td>
                                    <td class="text-sm-center">{{ props.item.matchingHistory.callHistory2.startLocationName }}</td>
                                    <td class="text-sm-center">{{ props.item.matchingHistory.callHistory2.endLocationName }}</td>
                                </template>
                            </v-data-table>
                        </v-list>
                    </v-flex>

                    <v-flex xs12 sm6 md1>
                        <v-select
                                label="중간 하차 승객"
                                required
                                :items="destPassengers"
                                v-model="firstDestPassenger.id"
                        ></v-select>
                    </v-flex>

                    <v-flex xs12 sm6 md1>
                        <v-dialog
                                ref="dialog"
                                v-model="isVisibleFirstDestTimePicker"
                                :return-value.sync="firstDestPassenger.time"
                                persistent
                                lazy
                                full-width
                                width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                        v-model="firstDestPassenger.time"
                                        label="중간 하차 시간"
                                        prepend-icon="access_time"
                                        readonly
                                        v-on="on"
                                ></v-text-field>
                            </template>
                            <v-time-picker
                                    v-if="isVisibleFirstDestTimePicker"
                                    v-model="firstDestPassenger.time"
                                    full-width
                            >
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="isVisibleFirstDestTimePicker = false">Cancel</v-btn>
                                <v-btn flat color="primary" @click="$refs.dialog.save(firstDestPassenger.time)">OK</v-btn>
                            </v-time-picker>
                        </v-dialog>
                    </v-flex>

                    <v-flex xs12 sm6 md1>
                        <v-text-field
                                mask="######"
                                label="중간 미터기 요금"
                                v-model="taxiFee.firstDestTaxiFee"
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md1>
                        <v-select
                                label="최종 하차 승객 (목적지 변경 승객)"
                                required
                                :items="destPassengers"
                                v-model="secondDestPassenger.id"
                        ></v-select>
                    </v-flex>

                    <v-flex xs12 sm6 md1>
                        <v-dialog
                                ref="dialog2"
                                v-model="isVisibleSecondDestTimePicker"
                                :return-value.sync="secondDestPassenger.time"
                                persistent
                                lazy
                                full-width
                                width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                        v-model="secondDestPassenger.time"
                                        label="최종 하차 시간 (목적지 변경 승객)"
                                        prepend-icon="access_time"
                                        readonly
                                        v-on="on"
                                ></v-text-field>
                            </template>
                            <v-time-picker
                                    v-if="isVisibleSecondDestTimePicker"
                                    v-model="secondDestPassenger.time"
                                    full-width
                            >
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="isVisibleSecondDestTimePicker = false">Cancel</v-btn>
                                <v-btn flat color="primary" @click="$refs.dialog2.save(secondDestPassenger.time)">OK</v-btn>
                            </v-time-picker>
                        </v-dialog>
                    </v-flex>

                    <v-flex xs12 sm6 md1>
                        <v-text-field
                                label="최종 하차 지역 (목적지 변경 지역)"
                                v-model="secondDestPassenger.destLocationName"
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md1>
                        <v-text-field
                                mask="######"
                                label="최종 미터기 요금"
                                v-model="taxiFee.finalTaxiFee"
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md1>
                        <v-text-field
                                mask="######"
                                label="추가 요금(통행료)"
                                v-model="taxiFee.extraFee"
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md3>
                        <v-btn color="blue-grey" dark @click="calculate">계산하기</v-btn>
                    </v-flex>

                    <template v-if="isVisibleSettlement">
                        <v-flex xs12 sm6 md2>
                            <v-text-field
                                    mask="######"
                                    :label="'중간 하차 승객 정산 금액 (서비스 이용료 미포함)'"
                                    v-model="firstDestPassenger.amt"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md2>
                            <v-text-field
                                    mask="######"
                                    :label="'최종 하차 승객 정산 금액 (서비스 이용료 미포함)'"
                                    v-model="secondDestPassenger.amt"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md3>
                            <v-btn color="danger" dark @click="settlement">정산</v-btn>
                        </v-flex>
                    </template>
                </template>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    export default {
        components: {},
        data () {
            return {
                isVisibleFirstDestTimePicker: false,
                isVisibleSecondDestTimePicker: false,
                isVisibleSettlement: false,
                driverUsageId: null,
                driverUsage: null,
                destPassengers: [],
                taxiFee: {
                    firstDestTaxiFee: null,
                    finalTaxiFee: null,
                    extraFee: null
                },
                firstDestPassenger: {
                    id: null,
                    time: null,
                    amt: null
                },
                secondDestPassenger: {
                    id: null,
                    time: null,
                    amt: null,
                    destLocationName: null
                },
                complex: {
                    driverUsageHeader1: [
                        {
                            text: '운행 고유번호',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '콜 종류',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '콜 수락 시간',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '상태',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '출발지',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '도착지',
                            align: 'center',
                            sortable: false
                        },
                    ],
                    driverUsageHeader2: [
                        {
                            text: '기존 승차 순서',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '기존 하차 순서',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '기존 첫 번째 출발지',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '기존 두 번째 출발지',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '기존 첫 번째 도착지',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '기존 두 번째 도착지',
                            align: 'center',
                            sortable: false
                        }
                    ],
                    driverHeader: [
                        {
                            text: '기사 고유번호',
                            value: 'driverId',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '기사 이름',
                            value: 'driver.personalInfo.name',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '기사 전화번호',
                            value: 'driver.phoneNumber',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '택시번호',
                            value: 'carNum',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '택시모델명',
                            value: 'carModelName',
                            align: 'center',
                            sortable: false
                        },
                    ],
                    passengerHeader: [
                        {
                            text: '승객 고유번호',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '승객 이름',
                            value: 'awaiter.id',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '승객 전화번호',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '승객 성별',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '승객 좌석',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '혼자 탔을 때 예상요금',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '같이 탔을 때 예상요금 (서비스 이용료 포함)',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '승객 출발지',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '승객 목적지',
                            align: 'center',
                            sortable: false
                        },
                    ],
                    driverUsageCancelHistoryHeader: [
                        {
                            text: '취소 당시 상태',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '취소 요청자',
                            align: 'center',
                            sortable: false
                        },
                        {
                            text: '취소 사유',
                            align: 'center',
                            sortable: false
                        },
                    ],
                    items: []
                },
            };
        },
        mounted () {
            for (let i = 0; i < this.$parent.$children.length; i++) {
                if (this.$parent.$children[i].chkAutoReload != null) {
                    this.$parent.$children[i].chkAutoReload();
                }
            }
        },
        methods: {
            clearInitData() {
                this.complex.items = [];
                this.isVisibleFirstDestTimePicker = false;
                this.isVisibleSecondDestTimePicker = false;
                this.isVisibleSettlement = false;
                this.driverUsage = null;
                this.destPassengers = [];
                this.taxiFee = {
                    firstDestTaxiFee: null,
                    finalTaxiFee: null,
                    extraFee: null
                };
                this.firstDestPassenger = {
                    id: null,
                    time: null,
                    amt: null
                };
                this.secondDestPassenger = {
                    id: null,
                    time: null,
                    amt: null,
                    destLocationName: null
                };
            },
            getDriverUsage() {
                if(!this.driverUsageId) {
                    alert('운행 고유번호를 정확히 입력해 주세요.');
                    return;
                }

                this.clearInitData();

                const parameters = {
                    method: 'driverUsageRecordDetail',
                    'id': this.driverUsageId
                };

                this.$store.dispatch('banbanAPI', parameters)
                    .then(({ data }) => {
                        top.getApp.progress.dialog = false;

                        if(!this.validDriverUsage(data)) return;

                        this.driverUsage = data;
                        this.complex.items = [data];
                        this.createDestPassengers(data);
                    })
                    .catch((error) => {
                        if (top.getApp.commonError == null) {
                            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
                        }

                        top.getApp.commonError = null;
                        top.getApp.progress.dialog = false;
                    });
            },
            createDestPassengers(data) {
                let p1 = {text: '승객1 ('+data.matchingHistory.pickupUserId1+')', value: data.matchingHistory.pickupUserId1};
                let p2 = {text: '승객2 ('+data.matchingHistory.pickupUserId2+')', value: data.matchingHistory.pickupUserId2};

                this.destPassengers.push(p1, p2);
            },
            checkBasicCall(callOption) {
                return 'BASIC_NORMAL' === callOption || 'EXPRESS_ALONE' === callOption || 'PREMIUM_BLACK' === callOption;
            },
            lastDigitNumber(n) {
                return (n % 10);
            },
            calculate() {
                if(!this.validCalculateInfo()) return;

                let firstDestTaxiFee = parseInt(this.taxiFee.firstDestTaxiFee, 10);
                let finalTaxiFee = parseInt(this.taxiFee.finalTaxiFee, 10);
                let extraFee = parseInt(this.taxiFee.extraFee, 10);
                let firstDestPassengerAmt = Math.floor(firstDestTaxiFee / 2);
                if(extraFee > 0) {
                    firstDestPassengerAmt += extraFee / 2;
                }

                let secondDestPassengerAmt = finalTaxiFee + extraFee - firstDestPassengerAmt;

                this.firstDestPassenger.amt = firstDestPassengerAmt;
                this.secondDestPassenger.amt = secondDestPassengerAmt;

                this.isVisibleSettlement = true;
            },
            settlement() {
                if(!this.validSettlementInfo()) return;

                if(!confirm('해당 금액으로 정산하시겠습니까?')) return;

                let params = {
                    method: 'settlePassengerTaxiFee',
                    driverUsageId: this.driverUsage.id,
                    taxiFee: this.taxiFee.finalTaxiFee,
                    extraFee: this.taxiFee.extraFee,
                    firstDestPassengerId: this.firstDestPassenger.id,
                    firstDestPassengerAmt: this.firstDestPassenger.amt,
                    firstDestTimestamp: this.createDestTimestamp(this.firstDestPassenger.time),
                    secondDestPassengerId: this.secondDestPassenger.id,
                    secondDestPassengerAmt: this.secondDestPassenger.amt,
                    secondDestTimestamp: this.createDestTimestamp(this.secondDestPassenger.time),
                    secondDestLocationName: this.secondDestPassenger.destLocationName
                };

                this.$store.dispatch('banbanAPI', params)
                    .then(({ data }) => {
                        top.getApp.progress.dialog = false;

                        if(data.statusCode && data.statusCode != '200'){
                            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
                            return;
                        }

                        alert('정산되었습니다.');
                    })
                    .catch((error) => {
                        if (top.getApp.commonError == null) {
                            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
                        }
                        top.getApp.commonError = null;
                        top.getApp.progress.dialog = false;
                    });
            },
            createDestTimestamp(time) {
                let timeArr = time.split(':');
                let result = moment({hour: timeArr[0], minute: timeArr[1]}).utcOffset(9).format('YYYY.MM.DD HH:mm:ss');
                return result;
            },
            validDriverUsage(data) {
                if(data.statusCode && data.statusCode != '200'){
                    alert('운행 고유번호가 올바르지 않거나 운행 정보가 존재하지 않습니다.');
                    return false;
                }

                if(this.checkBasicCall(data.callOption)) {
                    alert('일반콜은 별도 정산이 불가능합니다.');
                    return false;
                }

                if(data.state !== 'CANCEL') {
                    alert('취소된 콜에 대해서만 정산이 가능합니다.');
                    return false;
                }

                return true;
            },
            validCalculateInfo() {
                let firstDestPassenger = this.firstDestPassenger;
                let secondDestPassenger = this.secondDestPassenger;
                let taxiFee = this.taxiFee;

                if(!firstDestPassenger.id) {
                    alert('중간 하차 승객을 선택해 주세요.');
                    return false;
                }

                if(!firstDestPassenger.time) {
                    alert('중간 하차 시간을 입력해 주세요.');
                    return false;
                }

                if(!taxiFee.firstDestTaxiFee || taxiFee.firstDestTaxiFee < 1 || this.lastDigitNumber(taxiFee.firstDestTaxiFee) !== 0) {
                    alert('중간 미터기 요금을 정확하게 입력해 주세요.\n(1원 단위 입력불가)');
                    return false;
                }

                if(!secondDestPassenger.id) {
                    alert('최종 하차 승객을 선택해 주세요.');
                    return false;
                }

                if(firstDestPassenger.id === secondDestPassenger.id) {
                    alert('중간 하차 승객과 최종 하차 승객이 동일할 수 없습니다.\n\n다시 선택해 주세요.');
                    return false;
                }

                if(!secondDestPassenger.time) {
                    alert('최종 하차 시간을 입력해 주세요.');
                    return false;
                }

                if(!secondDestPassenger.destLocationName) {
                    alert('최종 하차 지역을 입력해 주세요.');
                    return false;
                }

                if(!taxiFee.finalTaxiFee || taxiFee.finalTaxiFee < 1 || this.lastDigitNumber(taxiFee.finalTaxiFee) !== 0) {
                    alert('최종 미터기 요금을 정확하게 입력해 주세요.\n(1원 단위 입력불가)');
                    return false;
                }

                if(!taxiFee.extraFee || this.lastDigitNumber(taxiFee.extraFee) !== 0) {
                    alert('추가 요금(통행료)을 입력해 주세요.\n(1원 단위 입력불가)');
                    return false;
                }

                let finalFee = parseInt(taxiFee.finalTaxiFee, 10) + parseInt(taxiFee.extraFee, 10);
                if(taxiFee.firstDestTaxiFee >= finalFee) {
                    alert('중간 미터기 요금이 결제금액(최종 미터기 요금 + 추가 요금)보다 크거나 같을 수 없습니다.');
                    return false;
                }

                return true;
            },
            validSettlementInfo() {
                if(!this.firstDestPassenger.amt || this.firstDestPassenger.amt < 1 || this.lastDigitNumber(this.firstDestPassenger.amt) !== 0) {
                    alert('승객1 정산금액을 올바르게 입력해 주세요.\n(1원 단위 입력불가)');
                    return false;
                }

                if(!this.secondDestPassenger.amt || this.secondDestPassenger.amt < 1 || this.lastDigitNumber(this.secondDestPassenger.amt) !== 0) {
                    alert('승객2 정산금액을 올바르게 입력해 주세요.\n(1원 단위 입력불가)');
                    return false;
                }

                let totalFee = parseInt(this.taxiFee.finalTaxiFee, 10) + parseInt(this.taxiFee.extraFee, 10);
                let sumPassengerFee = parseInt(this.firstDestPassenger.amt, 10) + parseInt(this.secondDestPassenger.amt, 10);

                if(totalFee !== sumPassengerFee) {
                    alert('결제금액(최종 미터기 요금 + 추가 요금)과 정산금액 금액이 일치하지 않습니다.');
                    return false;
                }

                return true;
            },
            changeGenderText(gender) {
                return top.getApp.changeGenderText(gender);
            },
            changeCallCancelReasonText(reason) {
                return top.getApp.changeCallCancelReasonText(reason);
            },
            changeRunningStateText(state) {
                return top.getApp.changeRunningStateText(state);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/pages/settlement/PassengerSettlement.vue